
//取得护理评估数据整理，需要将部分组件的value值解析。如多选框的[]
const valueParse = ['MultiSelect','MultiSelectAndInput','Verdict','RadioSelect','RadioSelectAndInput'];

export function arrangeData(r) {
    for (let i = 0;i<r.length;i++){
        let topics = r[i];
        for (let t = 0;t<topics.length;t++){
            let topic = topics[t];
            if(topic.hasOwnProperty('value')){
                console.log('value',i,t);
                if(typeof topic.value == 'string' &&
                    topic.value.length >=1 &&
                    valueParse.indexOf(topic.name) != -1
                ){
                    topic.value = JSON.parse(topic.value);
                }
            }
            if(topic.hasOwnProperty('props')){
                console.log('props',i,t);
                if(typeof topic.props == 'string' && topic.props.length>=2){
                    topic.props = JSON.parse(topic.props);
                }
            }
        }
    }
    return r;
}


export function arrangeSubmitData(newData) {
    for (let i = 0;i<newData.length;i++){
        let topics = newData[i];
        for (let t = 0;t<topics.length;t++){
            let topic = topics[t];
            if(topic.hasOwnProperty('value') && typeof topic.value != 'string' ){
                if(topic.value != null){
                    topic.value = JSON.stringify(topic.value);
                }
            }
        }
    }
    return newData;
}
